import React, { useEffect } from "react";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  clearClientActivityLogsList,
  clearInquiryLeadActivityLogsList,
} from "./clientActivityTabSlice";
import ClientActivityLogs from "../clientForm/ClientActivityLogs";
import { Typography } from "@progress/kendo-react-common";
import { clearUserDetails } from "../user/userSlice";
import { getAllActivityLogs } from "./services/clientActivityTab.services";
import { useLocation } from "react-router-dom";

const InquiryLeadActivityLogs: React.FC = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const alignment = useAppSelector((state) => state.activityLog.alignment);
  const NBInquiryTypeGUID = location.state?.NBInquiryTypeGUID;
  const NBActivityType = location.state?.NBActivityType;
  const ActivityLogType = location.state?.ActivityLogType;
  useEffect(() => {
    const payload = {
      PastActivityFilters: alignment === "PAST" ? 1 : 0,
      NBInquiryTypeGUID: NBInquiryTypeGUID,
      CreatedBy: null,
      FromDate: "",
      ToDate: "",
      NBActivityType: NBActivityType,
    };
    dispatch(getAllActivityLogs(payload));
  }, [alignment]);

  useEffect(() => {
    return () => {
      dispatch(clearUserDetails());
      dispatch(clearClientActivityLogsList());
      dispatch(clearInquiryLeadActivityLogsList());
    };
  }, []);
  return (
    <>
      <GridLayout gap={{ rows: 10, cols: 20 }} cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            {ActivityLogType} Activity Log
          </Typography.h4>
        </GridLayoutItem>
        <GridLayoutItem>
          <ClientActivityLogs client={false} />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

export default InquiryLeadActivityLogs;
